import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Helpers } from '../../utils/helpers';
import { REPORT_TABS } from './report-tabs.config';

export const reportsLandingGuard: CanActivateFn = () => {
  const helpers = inject(Helpers);
  const router = inject(Router);

  const firstAllowed = REPORT_TABS.find((tab) => helpers.handleCheckPermissions(tab.permissions));

  return router.createUrlTree(firstAllowed ? ['/reports', firstAllowed.link] : ['/']);
};
